import * as React from "react";
import cx from "classnames";

import { TrackClick } from "../../../hoc";
import { ProductStyle } from "../../../models";

export interface StyleItemProps extends ProductStyle {
  onClick: () => void;
  active?: boolean;
}

const getMainClasses = ({ active }: StyleItemProps) =>
  cx("style-list__style-item", { "style-list__style-item--active": active });

const StyleItem = (props: StyleItemProps) => (
  <div className="col-md-4 col-sm-6">
    <div className={getMainClasses(props)}>
      <h3>{props.name}</h3>
      <TrackClick
        category="wizard"
        action={props.active ? "Unclicked style" : "Clicked style"}
        label={props.name}
        onClick={props.onClick}
        render={handleClick => (
          <img
            className="img-responsive"
            src={props.image}
            onClick={handleClick}
          />
        )}
      />
      {props.active && (
        <span className="check">
          <i className="fa fa-check" />
        </span>
      )}
    </div>
  </div>
);

export default StyleItem;



// WEBPACK FOOTER //
// ./src/routes/WizardStyleChoice/components/StyleItem.tsx